import { render, staticRenderFns } from "./Courses.vue?vue&type=template&id=7ee6625f&"
import script from "./Courses.vue?vue&type=script&lang=ts&"
export * from "./Courses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports